import type { FetchBaseQueryError } from "@reduxjs/toolkit/query";

// 401 с этими reason — ошибка бизнес-логики, а не истёкший токен:
// обновлять токен и повторять запрос (лишняя попытка пароля) нельзя.
const NON_AUTH_401_REASONS = ["invalid_current_password"];

const getReason = (data: unknown): string | null => {
  if (!data || typeof data !== "object" || !("reason" in data)) return null;
  return typeof data.reason === "string" ? data.reason : null;
};

export const isAuthExpiredError = (
  error: FetchBaseQueryError | undefined,
): boolean => {
  if (!error || error.status !== 401) return false;
  const reason = getReason(error.data);
  return reason === null || !NON_AUTH_401_REASONS.includes(reason);
};
